import {
  ISharingInformation
} from '../../interfaces/SharingInterfaces';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import * as React from 'react';
import stringsResx from '../Share.resx';
import { createRef } from 'office-ui-fabric-react/lib/Utilities';
import { autobind } from 'office-ui-fabric-react/lib/Utilities';
import { Button } from 'office-ui-fabric-react/lib/Button';
import { copyToClipboard } from '@ms/odsp-utilities/lib/clipboard/CopyHelper';
import './Error.scss';
import * as PropTypes from 'prop-types';

export interface IErrorProps {
  sharingInformation: ISharingInformation;
  showReportProblem: boolean;
}

export interface IErrorState {
  areDetailsVisible: boolean;
}

export class Error extends React.Component<IErrorProps, IErrorState> {
  private _errorMessage = createRef<HTMLElement>();
  private _resize: () => void;

  static contextTypes = {
    resize: PropTypes.func.isRequired
  };

  constructor(props: IErrorProps, context: any) {
    super(props);
    this._resize = context.resize;
    this.state = {
      areDetailsVisible: false
    };
  }

  public componentDidUpdate(prevProps: IErrorProps, prevState: IErrorState) {
    // Focus the error message (if it exists) for accessibility purposes
    if (this._errorMessage.current) {
      this._errorMessage.current.focus();
    }
    this._resize();
  }

  public render(): React.ReactElement<IErrorProps> {
    const strings = stringsResx;
    const technicalDetails = this.state.areDetailsVisible && this.props.sharingInformation.debugErrorMessage ?
      <div className='od-Share-error-technical'>
        <h4> { strings.errorTechnicalDetails } </h4>
        <div>
          { this.props.sharingInformation.debugErrorMessage }
        </div>
        <Button className='od-Share-error-copy' onClick={ this._onCopyToClipboardClicked } >{ strings.errorCopyTechnicalDetails }</Button>
        <span className='od-Share-error-clear'></span>
      </div> :
      null;
    const reportProblem = this.props.showReportProblem ?
      <div className='od-Share-error-report'>
        { strings.errorReportProblem }
      </div>
      : null;
    const errorDetailsToggle = this.props.sharingInformation.debugErrorMessage ?
      <div className='od-Share-error-details' onClick={ this._onToggleDetailsClicked }>
        { this.state.areDetailsVisible ? strings.errorHideDetails : strings.errorShowDetails }
        <Icon
          iconName={ this.state.areDetailsVisible ? 'ChevronUp' : 'ChevronDown' }
          className='od-Share-error-chevron' />
      </div>
      : null;

    return (
      <div className='od-Share-error' role='alert' tabIndex={ 0 } ref={ this._errorMessage }>
        <h2> { strings.errorTitle } </h2>
        <div className='od-Share-error-message'>
          <p> { this.props.sharingInformation.errorMessage } </p>
          { this.props.sharingInformation.fixItUrl && <a href={ this.props.sharingInformation.fixItUrl } target='_blank'>{ stringsResx.fixIt }</a> }
          { technicalDetails }
        </div>
        <div>
          { errorDetailsToggle }
          { reportProblem }
        </div>
      </div>
    );
  }

  @autobind
  private _onToggleDetailsClicked() {
    this.setState({
      areDetailsVisible: !this.state.areDetailsVisible
    })
  }

  @autobind
  private _onCopyToClipboardClicked() {
    copyToClipboard(this.props.sharingInformation.debugErrorMessage || '');
  }
}